import { render, staticRenderFns } from "./su-container.vue?vue&type=template&id=3b690cc2&scoped=true"
import script from "./su-container.vue?vue&type=script&lang=js"
export * from "./su-container.vue?vue&type=script&lang=js"
import style0 from "./su-container.vue?vue&type=style&index=0&id=3b690cc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b690cc2",
  null
  
)

export default component.exports